import { SafeAreaView, View } from 'react-native'
import styled from 'styled-components'
import TouchableNoFeedback from '../../../../elements/controls/TouchableNoFeedback/TouchableNoFeedback'
import { media } from '../../../../style/media'

const Backdrop = styled(View)`
  background-color: rgba(0, 0, 0, ${(props) => (props.visible ? props.opacity || 0.4 : 0)});
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

const Wrapper = styled(SafeAreaView)`
  flex: 1;
`

export const Controls = ({ visible, children, ...props }) => (
  <Backdrop as={TouchableNoFeedback} visible={visible} {...props}>
    {!visible ? null : <Wrapper>{children}</Wrapper>}
  </Backdrop>
)

Controls.Backdrop = Backdrop

Controls.Header = styled(View)`
  flex-direction: row;
  z-index: ${(props) => props.theme.zIndex.modals}; /* For caption controls pop-up */
  padding-top: ${(props) => props.theme.spacing.sm}px;
  justify-content: space-between;

  ${media.md`
    padding: ${(props) => props.theme.spacing.xs}px 0;
  `};
`

Controls.Body = styled(TouchableNoFeedback)`
  flex: 1;
  flex-direction: ${(props) => (props.row ? 'row' : 'column')};
`

Controls.Footer = styled(View)`
  padding: ${(props) => props.theme.spacing.sm}px 0;

  ${media.md`
    padding: ${(props) => props.theme.spacing.md}px ${(props) => props.theme.spacing.sm}px;
  `};
`

Controls.Buttons = styled(View)`
  flex-direction: row;
  margin-left: ${(props) => (props.rightAlign ? 'auto' : 0)};

  ${(props) => props.justifyContent && `justify-content: ${props.justifyContent};`}
`

export default Controls
